interface Props {
  width?: number;
  height?: number;
}

const AddVideo = ({
  width = 48,
  height = 48,
  ...rest
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12.7 12.7"
    height={height}
    width={width}
    {...rest}
  >
    <g
      fill="none"
      stroke="#000"
      strokeWidth={0.529}
      strokeLinecap="round"
      strokeMiterlimit={10}
    >
      <path d="M10.57 3.338a.813.813 0 00-.812-.812H2.942a.813.813 0 00-.812.812v6.024c0 .448.364.812.812.812h6.816a.813.813 0 00.812-.812z" />
      <path
        d="M5.04 7.237V5.463c0-.487.345-.687.768-.443l1.535.887c.423.243.423.643 0 .886l-1.535.887c-.423.244-.768.044-.768-.443z"
        opacity={0.999}
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default AddVideo;
